import { useState } from "react";
import "./style.css";

export default function AddFeatured({ featured = [], updateDetails, setShowFeatured }) {
  const [featuredList, setFeaturedList] = useState(featured || []);
  const [showAddForm, setShowAddForm] = useState(false);
  const [newFeatured, setNewFeatured] = useState({
    title: "",
    description: "",
    link: "",
    type: "other"
  });

  const addFeaturedItem = () => {
    if (newFeatured.title.trim()) {
      setFeaturedList([...featuredList, { ...newFeatured, title: newFeatured.title.trim() }]);
      setNewFeatured({ title: "", description: "", link: "", type: "other" });
      setShowAddForm(false);
    }
  };

  const removeFeaturedItem = (index) => {
    const updatedFeatured = featuredList.filter((_, i) => i !== index);
    setFeaturedList(updatedFeatured);
  };

  const saveFeatured = async () => {
    await updateDetails({ featured: featuredList });
    setShowFeatured(false);
  };

  const handleInputChange = (field, value) => {
    setNewFeatured(prev => ({ ...prev, [field]: value }));
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'work': return '💼';
      case 'education': return '🎓';
      case 'achievement': return '🏆';
      case 'project': return '🚀';
      default: return '⭐';
    }
  };

  const isEditing = featured.length > 0;

  return (
    <div className="intro_editor">
      <div className="intro_editor_title">{isEditing ? "Edit featured" : "Add featured"}</div>

      <div className="featured_content">
        <div className="featured_list">
          {featuredList.map((item, index) => (
            <div key={index} className="featured_item">
              <div className="featured_item_header">
                <span className="featured_type_icon">{getTypeIcon(item.type)}</span>
                <div className="featured_item_info">
                  <h4>{item.title}</h4>
                  {item.description && <p>{item.description}</p>}
                  {item.link && (
                    <a href={item.link} target="_blank" rel="noopener noreferrer" className="featured_link">
                      View Link
                    </a>
                  )}
                </div>
                <button 
                  onClick={() => removeFeaturedItem(index)}
                  className="remove_featured_btn"
                  title="Remove featured item"
                >
                  ×
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAddForm ? (
          <button 
            onClick={() => setShowAddForm(true)}
            className="add_featured_item_btn"
          >
            + Add Featured Item
          </button>
        ) : (
          <div className="add_featured_form">
            <div className="form_row">
              <select
                value={newFeatured.type}
                onChange={(e) => handleInputChange('type', e.target.value)}
                className="featured_type_select"
              >
                <option value="other">Other</option>
                <option value="work">Work</option>
                <option value="education">Education</option>
                <option value="achievement">Achievement</option>
                <option value="project">Project</option>
              </select>
            </div>
            
            <div className="form_row">
              <input
                type="text"
                placeholder="Title (Required)"
                value={newFeatured.title}
                onChange={(e) => handleInputChange('title', e.target.value)}
                className="featured_input"
                maxLength={100}
                required
              />
            </div>
            
            <div className="form_row">
              <textarea
                placeholder="Description (Optional)"
                value={newFeatured.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
                className="featured_textarea"
                maxLength={300}
                rows={3}
              />
            </div>
            
            <div className="form_row">
              <input
                type="url"
                placeholder="Link (Optional)"
                value={newFeatured.link}
                onChange={(e) => handleInputChange('link', e.target.value)}
                className="featured_input"
              />
            </div>
            
            <div className="form_actions">
              <button 
                onClick={addFeaturedItem}
                className="blue_btn"
                disabled={!newFeatured.title.trim()}
              >
                Add
              </button>
              <button 
                onClick={() => {
                  setShowAddForm(false);
                  setNewFeatured({ title: "", description: "", link: "", type: "other" });
                }}
                className="gray_btn"
              >
                Cancel
              </button>
            </div>
          </div>
        )}

        {featuredList.length === 0 && !showAddForm && (
          <div className="no_featured_message">
            No featured items yet. Showcase your achievements, projects, and more!
          </div>
        )}
      </div>

      <div className="intro_editor_actions">
        <button className="intro_ghost_btn" onClick={() => setShowFeatured(false)}>
          Cancel
        </button>
        <button className="intro_save_btn" onClick={saveFeatured}>
          Save
        </button>
      </div>
    </div>
  );
} 